import camelcaseKeys from 'camelcase-keys';
import { NewsItem } from '@libs/api-reference';

function transformSingleNews(news): NewsItem {
  return camelcaseKeys(news, { deep: true });
}

export { transformSingleNews };
